import { IPartner, TPartnerDifference } from 'clickNgo/entities/partner/models'

export function sortPartnerDifference(a: TPartnerDifference, b: TPartnerDifference) {
  const order: Array<keyof IPartner> = ['companyLegalName', 'communicationName', 'taxId']

  const indexA = order.indexOf(a.field)
  const indexB = order.indexOf(b.field)

  if (indexA !== -1 || indexB !== -1) {
    // If both keys exist in the order array, sort by their order index
    if (indexA === -1) return 1 // a is not in the order list, b is, so b comes first
    if (indexB === -1) return -1 // b is not in the order list, a is, so a comes first
    return indexA - indexB // Both are in the list, sort by their positions in the list
  }

  // If neither key is in the list, sort them alphabetically by 'field'
  return a.field.localeCompare(b.field)
}
